// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3eW-6","noInteraction":"EventWrapper_noInteraction__1JVq4"};